import { authedInstance } from ".";

export async function createEnquiryFormAPI(payload) {
    console.log("Create Enquiry Form: ", payload);
    const res = await authedInstance.post("v1/app/groupBooking/enquiry", payload);
    console.log("Finish Create Enquiry Form: ", res.data);
    return res.data;
}